import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconArrowLeft } from '../../../assets/icons/icon-arrow-left.svg';
import { ReactComponent as IconShopCart } from '../../../assets/icons/icon-shop-cart.svg';

interface BackLinkProps {
  backPath: string;
  showLabel?: boolean;
}

export const AppHeaderBackLink: React.FC<BackLinkProps> = ({ backPath, showLabel = false }) => (
  <Link className="app-header__back" to={backPath} aria-label="Back to collection">
    <IconArrowLeft className="app-header__back-icon" aria-hidden />
    {showLabel && <span className="app-header__back-label">Back</span>}
  </Link>
);

interface CartLinkProps {
  cartItemCount: number;
}

export const AppHeaderCartLink: React.FC<CartLinkProps> = ({ cartItemCount }) => (
  <Link className="app-header__cart" to="/cart" aria-label="View cart">
    <IconShopCart className="app-header__cart-icon" aria-hidden />
    {cartItemCount > 0 && (
      <span className="app-header__cart-badge" aria-hidden>
        {cartItemCount}
      </span>
    )}
  </Link>
);
